import React from 'react';
import { formatLocationScope, getBookableStaffForService } from '../../../../locations/utils/locationAssignmentUtils';

export default function ServiceCard({
  service,
  onOpen,
  locations = [],
  staffOptions = [],
  contextLocationId = '',
}) {
  const assignedStaffCount = Array.isArray(service?.employeeIds) ? service.employeeIds.length : 0;
  const locationScope = formatLocationScope(service?.locationIds, locations);
  const bookableLocationIds = contextLocationId ? [contextLocationId] : service?.locationIds;
  const bookableStaffCount = getBookableStaffForService({
    service,
    staff: staffOptions,
    locationIds: bookableLocationIds,
    locations,
  }).length;
  const showMultiLocationMeta = locations.length > 1 && !contextLocationId;
  const hasBookingGap = showMultiLocationMeta && assignedStaffCount > 0 && bookableStaffCount === 0;

  return (
    <button className="ms2-circleBtn" type="button" onClick={onOpen} aria-label={`Edit ${service?.name || 'service'}`}>
      <div className="ms2-circleThumb" aria-hidden>
        {service?.imageUrl ? <img src={service.imageUrl} alt="" /> : <div className="ms2-circleFallback">🏷️</div>}
      </div>
      <div className="ms2-circleLabel" title={service?.name || ''}>
        {service?.name || 'Untitled'}
      </div>
      {showMultiLocationMeta ? (
        <div className="ms2-circleMeta">{locationScope.shortLabel || 'All locations'}</div>
      ) : null}
      <div className={`ms2-circleMeta ${assignedStaffCount === 0 || hasBookingGap ? 'ms2-circleMeta--warning' : ''}`}>
        {assignedStaffCount === 0
          ? 'Needs staff assignment'
          : hasBookingGap
            ? contextLocationId
              ? 'Assigned staff not at this location'
              : `${assignedStaffCount} assigned · not bookable`
            : contextLocationId
              ? `${bookableStaffCount} bookable here`
              : `${assignedStaffCount} staff assigned`}
      </div>
    </button>
  );
}

